document.addEventListener("DOMContentLoaded", () => {
  console.log('loaded');
  const discountCodeCopyButton = document.getElementById('discount-code-copy');

  discountCodeCopyButton.addEventListener('click', (event) => {   
    const discountCodeValue = discountCodeCopyButton.dataset.discountCode;

    // // Copy the text inside the text field
    navigator.clipboard.writeText(discountCodeValue);
    
    discountCodeCopyButton.innerText = "Copied!";

  });

});